export const SET_TOKEN   = 'SET_TOKEN' //设置id


// WEBPACK FOOTER //
// ./src/vuex/types.js